export const videoUrlNormalize = (url: string): string => {
  const videoIdStartIndex = url.indexOf('=');
  const videoIdEndIndex = url.indexOf('&');

  const videoId = videoIdEndIndex > 0
    ? url.slice(videoIdStartIndex + 1, videoIdEndIndex)
    : url.slice(videoIdStartIndex + 1);

  return `https://www.youtube.com/embed/${videoId}`;
}